<script>
    import { Bar } from 'vue-chartjs'

    export default {
        name: 'LineChart',
        extends: Bar,
        props: [
            'labels',
            'datasets'
        ],
        mounted () {
            this.renderChart(
                {
                    labels: this.labels,
                    datasets: this.datasets
                },
                {
                    ...this.options,
                    ...{
                        responsive: true,
                        maintainAspectRatio: false
                    }
                }
            )
        }
    }
</script>